import React, { useContext, useEffect, useRef } from 'react';
import { FuelInteractiveIcon, FuelTypography } from '@frete.com/fuel-react';
import { FuelFlex } from '@frete.com/fuel-station-react';
import AppContext from '@context';
import BaseModal from '@components/ui/BaseModal';
import EditAddress from '@components/ui/EditAddress';
import { useTimeout } from '@hooks/useTimeout';
import useAmplitude from '@hooks/useAmplitude';
import * as Styled from './ModalUpdatedAddressStyles';

function ModalUpdatedAddress() {
  const {
    state: { ui },
    dispatch,
  } = useContext(AppContext);

  const { amplitudeEvent } = useAmplitude();
  const baseRef = useRef<HTMLDivElement>(null);
  const contentRef = useRef<HTMLDivElement>(null);
  const actionRefUpdatedAddress = useRef<HTMLDivElement>(null);
  const { isShow, flow, journeyId } = ui.modalUpdatedAddress;

  const addTimeout = useTimeout();

  function onClose() {
    return new Promise<void>((resolve) => {
      baseRef.current?.classList.remove('animated');
      contentRef.current?.classList.remove('animated');
      actionRefUpdatedAddress.current?.classList.remove('animated');

      addTimeout(() => {
        dispatch({
          type: 'ui_modalUpdatedAddress_set_show',
          payload: {
            isShow: false,
            flow, // mantem o mesmo flow de quando a modal estava aberta
            journeyId: '',
          },
        });
        resolve();
      }, 200);
    });
  }

  function handleClose() {
    onClose().then(() => {
      if (flow === 'modalMonitoring') {
        dispatch({
          type: 'ui_modalMonitoring_set_show',
          payload: {
            isShow: true,
            journeyId: journeyId || '',
          },
        });
      }
    });
  }

  const eventMonitoringViewed = (source: string) => {
    amplitudeEvent('journey_monitoring_viewed', {
      source,
      journey_id: journeyId,
    });
  };

  useEffect(() => {
    if (isShow) {
      addTimeout(() => {
        baseRef.current?.classList.add('animated');
        contentRef.current?.classList.add('animated');
        actionRefUpdatedAddress.current?.classList.add('animated');
      }, 200);
    }
  }, [isShow]);

  return (
    <BaseModal
      isOpen={isShow}
      onClose={() => {
        handleClose();

        eventMonitoringViewed('area-cinza-adicionar-rota');
      }}
      innerRef={baseRef}
      vAlignment="top"
      hAlignment="right"
      hOverlay
    >
      <Styled.Content isShow={isShow} ref={contentRef}>
        <FuelFlex defaultProps={{ alignItems: 'flex-start', gap: 'km6' }}>
          <FuelInteractiveIcon
            data-testid="ModalUpdatedAddressCloseBtn"
            icon="close"
            size="large"
            onClick={() => {
              handleClose();

              eventMonitoringViewed('x-fechar-drawer-adicionar-rota');
            }}
          />
          <div>
            <FuelTypography
              size="heading-md"
              weight="bold"
              color="neutral-strong"
              spacingTop={0}
              spacingBottom={0}
              spacingRight={8}
            >
              Rota de monitoramento
            </FuelTypography>
            <FuelTypography
              size="caption"
              weight="bold"
              color="neutral-default"
              displayInline
            >
              Para localizarmos sua carga informe os dados abaixo:
            </FuelTypography>
          </div>
        </FuelFlex>
        <EditAddress
          isShow
          journeyId={journeyId}
          renderLocation="modalInsertLocation"
          onCancel={() => handleClose()}
          onSucess={() => handleClose()}
        />
      </Styled.Content>
    </BaseModal>
  );
}

export default ModalUpdatedAddress;
